export default function TodaysDate() {
  const day = new Date();
  return day.toISOString().split('T')[0];
}
